import * as React from 'react';
import { observer } from 'mobx-react-lite';

import { QuestionTypeEnum, SkillEnum } from '@doltech/utils/lib/constants';
import { IeltsBookThumbnailPromotionBanner } from '@doltech/ui/lib/figma/PromotionBanner/PremadeBanner/IeltsBookThumbnailPromotionBanner';
import { IeltsCourseThumbnailPromotionBanner } from '@doltech/ui/lib/figma/PromotionBanner/PremadeBanner/IeltsCourseThumbnailPromotionBanner';
import { WarningBanner } from '@doltech/ui/lib/figma/PromotionBanner/WarningBanner';

import { useTestResultStore } from '../model/test-result.hook';
import { BlankChoiceExplanationSummaryAndDetail } from './explanantion-with-summary/BlankChoiceExplanationSummaryAndDetail';
import { SingleChoiceExplanationSummaryAndDetail } from './explanantion-with-summary/SingleChoiceExplanationSummaryAndDetail';

interface ExplanationWithSummaryDetailProps {
  showTitle?: boolean;
}

export const ExplanationWithSummaryDetail = observer((props: ExplanationWithSummaryDetailProps) => {
  const { showTitle = true } = props;
  const store = useTestResultStore();
  const renderSummaryDetail = React.useCallback(() => {
    if (store.currentQuestion) {
      const { corrections, correction, no, index, type } = store.currentQuestion;
      switch (type) {
        case QuestionTypeEnum.SHORT_ANSWER:
        case QuestionTypeEnum.SENTENCE_COMPLETE:
        case QuestionTypeEnum.NOTE_COMPLETION_NO_HINT:
        case QuestionTypeEnum.NOTE_COMPLETION_WITH_HINT:
        case QuestionTypeEnum.TABLE_COMPLETION:
        case QuestionTypeEnum.FLOWCHART_ANSWER:
        case QuestionTypeEnum.DIAGRAM_LABEL_COMPLETION:
        case QuestionTypeEnum.FLOW_CHART_COMPLEX:
          return (
            <BlankChoiceExplanationSummaryAndDetail
              key={no}
              correctAnswers={corrections}
              correction={correction}
              no={no}
              qIndex={index}
              showTitle={showTitle}
            />
          );
        default:
          return (
            <SingleChoiceExplanationSummaryAndDetail
              key={no}
              no={no}
              explanation={correction?.explanation}
              showTitle={showTitle}
            />
          );
      }
    }
    return null;
  }, [showTitle, store.currentQuestion]);
  return (
    <div className="explanation-summary-detail">
      {renderSummaryDetail()}
      <IeltsCourseThumbnailPromotionBanner mt="24px" />
      {store.skill === SkillEnum.READING && <IeltsBookThumbnailPromotionBanner mt="24px" />}
      <WarningBanner mt="24px" />
    </div>
  );
});
